<template>
  <div id="home" ref="fullPage" style="overflow: hidden">
    <div
      class="fullPageContainer"
      ref="fullPageContainer"
      @mousewheel="this.mouseWheelHandle"
      @DOMMouseScroll="this.mouseWheelHandle"
      style="width: 100%; height: 100vh; transition: all linear 0.7s"
    >
      <div class="pageOne" id="pageOne" @contextmenu.prevent>
        <!-- 背景图 -->
        <img
          id="image1"
          class="pageOneBackground"
          src="../assets/background.png"
          alt=""
          @load="this.onImageLoad"
        />
        <img
          v-if="this.isLoaded"
          id="image2"
          style="width: 100%; height: 100vh; position: absolute; top: 0; left: 0"
          src="@/assets/Frame-7_7.gif"
          alt=" My Image"
        />
        <!-- 小望云图标 -->
        <div style="position: absolute; left: 39.5vw; top: 35vh">
          <img style="width: 21.5vw; height: 20vh" src="@/assets/Group 2.png" alt="" />
        </div>

        <!-- 二维码 -->
        <div class="codeScan">
          <div>
            <img class="codeImg" src="/static/imgs/code.png" alt="" />
            <p
              style="
                color: #ffffff;
                font-size: 0.6vw;
                margin-left: 38%;
                margin-top: 0.4vw;
              "
            >
              扫码下载手机APP(安卓)
            </p>
          </div>
        </div>

        <div style="position: absolute; left: 5vw; top: 6vh">
          <!-- <img style="width: 6vw; height: 4vh" src="@/assets/Mask group.png" alt="" /> -->
          <img style="width: 8vw; height: 5h" src="@/assets/sclw.png" alt="" />
        </div>
        <div class="pageOneText" style="position: absolute; left: 29.5vw; top: 62vh">
          <p
            style="
              color: #b5c9d3;
              font-size: 1.2vw;
              font-family: Source Han Sans SC VF, Source Han Sans SC VF;
            "
          >
            结合云计算、大数据、人工智能等先进技术，为环保领域提供更高效、智能的服务
          </p>
        </div>
        <div @click="toassit" style="cursor: pointer">
          <img
            style="
              position: absolute;
              left: 46.5vw;
              top: 70.5vh;
              width: 9vw;
              height: 2.4vw;
            "
            src="../assets/Rectangle 4.png"
            alt=""
          />
          <span
            style="
              position: absolute;
              left: 48.6vw;
              top: 71.2vh;
              font-size: 1.2vw;
              color: white;
              font-family: Source Han Sans SC VF, Source Han Sans SC VF;
            "
            >立即使用</span
          >
        </div>
      </div>
      <div class="pageTwo">
        <div class="top">
          <div class="top-left">
            <!-- <img src="../../static/imgs/logo_home.png" height="90px" width="300px" /> -->
            <img style="width: 200px; height: 50px" src="@/assets/sclw.png" alt="" />
          </div>
          <div class="top-center">
            <div class="nav-box">
              <div
                class="nav-item"
                :class="activeNav == z + 1 ? ' active' : ''"
                v-for="(s, z) in menu"
                :key="z"
                :data-nav="z + 1"
              >
                <p>
                  <span>{{ s.province }}</span
                  ><img src="../../static/imgs/arrow.png" />
                </p>
                <div class="plat">
                  <a
                    :title="plat.name"
                    :href="plat.url"
                    :class="{ maintain: plat.maintain }"
                    target="_blank"
                    v-for="(plat, index) in s.plat"
                    :key="index"
                    >{{ plat.name }}</a
                  >
                </div>
              </div>
            </div>
            <div class="search-box">
              <div @click="flag.showSearch = false">
                <img src="../../static/imgs/close-icon-bb.png" />
              </div>
              <div class="search-ul-box">
                <input v-model="dimKey" @focus="focusInput" autocomplete="off" />
                <div class="search-ul niceScroll">
                  <ul>
                    <li v-show="fuzzyMenu.length == 0">无匹配数据~</li>
                    <li v-for="(s, z) in fuzzyMenu" :key="z">
                      <span>{{ s.name }}</span
                      ><a v-show="!s.maintain" target="_blank" :href="s.url">立即进入</a>
                    </li>
                  </ul>
                </div>
              </div>
              <span @click="searchMune">搜索</span>
            </div>
          </div>
          <div
            :class="flag.showSearch ? 'top-right active' : 'top-right'"
            @click="showSearchBox"
          >
            <img src="../../static/imgs/search_icon.png" />
          </div>
        </div>
        <div class="center" ref="scrollElement">
          <p class="center-p">PC端导航</p>
          <div>
            <div class="item" v-for="(i, index) in pcPlat" :key="index">
              <div class="item-title">
                <p class="img-icon">
                  <a :href="platObj[i].href" target="_blank"
                    ><img :src="platObj[i].img"
                  /></a>
                </p>
                <div class="item-info">
                  <a :href="platObj[i].href" target="_blank">
                    <p class="title">{{ platObj[i].title }}</p>
                  </a>
                  <p class="status">
                    <span>登录状态：</span
                    ><span
                      :style="{
                        color: platObj[i].tips == '登录成功' ? '#4bb86e' : '#ee483a',
                      }"
                      >{{ platObj[i].tips }}</span
                    >
                  </p>
                  <p class="status"><span>登录时间：</span>{{ lastLoginTime[i] }}</p>
                </div>
              </div>
            </div>
          </div>
          <p class="center-p">移动端监控</p>
          <div>
            <div class="item" v-for="(i, index) in mobilePlat" :key="index">
              <div class="item-title">
                <p class="img-icon">
                  <a :href="platObj[i].mhref" target="_blank"
                    ><img :src="platObj[i].img"
                  /></a>
                </p>
                <div class="item-info">
                  <a :href="platObj[i].mhref" target="_blank">
                    <p class="title">{{ platObj[i].title }}</p>
                  </a>
                  <p class="status">
                    <span>登录状态：</span
                    ><span
                      :style="{
                        color: platObj[i].tips == '登录成功' ? '#4bb86e' : '#ee483a',
                      }"
                      >{{ platObj[i].tips }}</span
                    >
                  </p>
                  <p class="status"><span>登录时间：</span>{{ lastLoginTime[i] }}</p>
                </div>
              </div>
            </div>
          </div>
          <!--      <img src="../../static/imgs/bg_home.png">-->
          <!--        <router-view></router-view>-->
        </div>
        <!--      <div class="footer">-->
        <!--        <div class="menu">-->
        <!--          <p @click="toUrl('/all',1)" :class="flag.activeMenu == 1 ? 'active' : ''"><span>所有平台</span></p>-->
        <!--          <p @click="toUrl('/liaowang',2)" :class="flag.activeMenu == 2 ? 'active' : ''"><span>瞭望平台</span></p>-->
        <!--          <p @click="toUrl('/huanbao',3)" :class="flag.activeMenu == 3 ? 'active' : ''"><span>环保平台</span></p>-->
        <!--          <p @click="toUrl('/zhujian',4)" :class="flag.activeMenu == 4 ? 'active' : ''"><span>住建平台</span></p>-->
        <!--          <p @click="toUrl('/chengguan',5)" :class="flag.activeMenu == 5 ? 'active' : ''"><span>城管平台</span></p>-->
        <!--          <p @click="toUrl('/qita',6)" :class="flag.activeMenu == 6 ? 'active' : ''"><span>其它平台</span></p>-->
        <!--        </div>-->
        <!--        <a href="http://www.beian.miit.gov.cn" target="_blank">蜀ICP备14027185号-2</a>-->
        <!--      </div>-->
        <div class="endFooter" style="background-color: black">
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
            ><p>蜀ICP备16036093号</p></a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let Base64 = require("js-base64").Base64;
import md5 from "js-md5";
import "../../static/js/menuInfo";

export default {
  name: "home",
  data() {
    return {
      isLoaded: false,
      timer: null,
      menu,
      flag: {
        activeMenu: 1,
        showSearch: false,
      },
      fullpage: {
        current: 1, // 当前的页面编号
        isScrolling: false, // 是否在滚动,是为了防止滚动多页，需要通过一个变量来控制是否滚动
        deltaY: 0, // 返回鼠标滚轮的垂直滚动量，保存的鼠标滚动事件的deleteY,用来判断是往下还是往上滚
      },
      startTime: undefined, // 记录触摸开始的时间
      startX: undefined, // 记录触摸开始的X坐标，本次主要实现的是上下滑动，所以当前坐标不做强制要求
      startY: undefined, // 记录触摸开始的Y坐标
      activeNav: "",
      searchMenu: [],
      fuzzyMenu: [],
      dimKey: "",
      v_niceScroll: null,
      account: "login",
      password: "sclw123456",
      showElements: true,
      lastScrollPosition: 0,
      platObj: {
        one: {
          tips: "",
          info: "",
          time: "",
          title: "环境网格化监管云平台-四川瞭望",
          img: "/static/imgs/nav_grid.png",
          href: "http://122.112.255.228:8082/web-grid-html_2.0/html/login.html",
          mhref:
            "http://weixin.liaowangyun.com:1500/sclw_grid_wx_1.0/html/login/login.html",
          discrib:
            "“环境网格化监管云平台”主要应用于市（区）级划设若干区域进行环境系统化监测监管。相比传统环境监测平台，网格化平台具备监测数据覆盖量大，更新速度快；报警处理责任落实到人，响应处理及时；分级管理简明高效；丰富多样的数据分析报表可视化，污染分布及演化趋势一目了然；同时为环境治理宏观决策提供可行性依据。",
        },
        two: {
          tips: "",
          info: "",
          time: "",
          title: "工地扬尘监管平台-成都建委",
          img: "/static/imgs/nav_yangcheng.png",
          href: "http://171.221.172.209:8082/static/cdjw-html-1.0/html/login.html",
          mhref: "http://yc.cdzj.chengdu.gov.cn:8082/static/cdjw-mobile-1.0/login.html",
          sessionID: "",
          prefix: "",
          fillStr: "",
          discrib:
            "“建筑工地扬尘监管平台”可实现远程颗粒物监测管控。用户可通过GIS地图站点标识，获取实时扬尘监测信息。支持远程超标报警、任务处理信息推送；污染统计率图、超标率占比图等功能。使监控人员及时发现问题，并提高应急处理问题能力。该软件平台具备统计排名机制，能为监管绩效提供科学依据。",
        },
        three: {
          tips: "",
          info: "",
          time: "",
          title: "环境大气污染监管平台-成都环保",
          img: "/static/imgs/nav_envir.png",
          href: "http://203.57.238.132:1500",
          discrib:
            "“环境大气污染监管平台”主要应用于市（区）级划设若干区域进行环境系统化监测监管。相比传统环境监测平台，网格化平台具备监测数据覆盖量大，更新速度快；报警处理责任落实到人，响应处理及时；分级管理简明高效；丰富多样的数据分析报表可视化，污染分布及演化趋势一目了然；同时为环境治理宏观决策提供可行性依据。",
        },
        four: {
          tips: "",
          info: "",
          time: "",
          title: "道路环境走航平台-成都环保",
          img: "/static/imgs/nav_zouhang.png",
          // href: "http://140.246.67.224:8089",
          href: "http://203.25.219.120:1500",
          mhref: "http://weixin.liaowangyun.com:1500/vehicle_mobile",
          discrib:
            "“环境大气走航监管平台”是针对移动式环境监测所研发的数据统计、分析、汇总的云平台，通过无线网络与移动式监测设备互联，共同组成道路大气污染路网监测体系，绘制城市网状区域污染云图，使得环境监测突破了地理上的限制，是当下针对性最强，适应力最好，监测成本最经济的环境监测体系重要组成部分。",
        },
        five: {
          tips: "",
          info: "",
          time: "",
          title: "环境数据质控平台-四川瞭望",
          img: "/static/imgs/nav_zhikong.png",
          href: "http://114.116.47.132:8082/web-grid-html_2.0/html/login.html",
          discrib:
            "“四川瞭望数据质控平台”主要应用于市（区）级划设若干区域进行环境系统化监测监管。相比传统环境监测平台，网格化平台具备监测数据覆盖量大，更新速度快；报警处理责任落实到人，响应处理及时；分级管理简明高效；丰富多样的数据分析报表可视化，污染分布及演化趋势一目了然；同时为环境治理宏观决策提供可行性依据。",
        },
        liaoc: {
          tips: "",
          info: "",
          time: "",
        },
        ffkq: {
          tips: "登录成功",
          info: "",
          time: "",
          title: "企业大气监管平台-峰峰矿区",
          img: "/static/imgs/nav_ff.png",
          href: "http://183.196.110.227:8082/",
        },
        hanc: {
          tips: "",
          info: "",
          time: "",
        },
        qdys: {
          tips: "",
          info: "",
          time: "",
          title: "大气污染监管平台-青岛住建",
          img: "/static/imgs/nav_qingdao.png",
          href: "http://47.104.132.222:8082/web-grid-html_2.0_qd/html/login.html",
        },
        qhd: {
          tips: "",
          info: "",
          time: "",
        },
        anshan: {
          tips: "",
          info: "",
          time: "",
          title: "大气环境监管平台-鞍山环保",
          img: "/static/imgs/nav_anshan.png",
          href: "http://203.86.74.218:8009/web-grid-html_2.0/html/login.html",
        },
        // 21
        guiyang: {
          tips: "",
          info: "",
          time: "",
          sessionID: "",
          prefix: "",
          fillStr: "",
          title: "工地扬尘监管平台-贵阳住建",
          img: "/static/imgs/nav_guiyang.png",
          href: "http://114.115.222.141:8093",
          // href: "http://222.85.139.153:8093/static/cdjw-pc-ty/html/login.html",
          mhref: "http://114.115.222.141:8093/static/cdjw-mobile-1.0/login.html",
        },
        noiselw: {
          tips: "",
          info: "",
          time: "",
          title: "声环境监管平台-四川瞭望",
          img: "/static/imgs/noiseLogo.png",
          // href: "http://140.246.67.224:8089",
          href: "http://114.115.143.236:8082/",
          discrib: "",
        },
        newCloudPlatform: {
          tips: "",
          info: "",
          time: "",
          title: "智慧监管云平台-四川瞭望",
          img: "/static/imgs/nav_zhikong.png",
          // href: "http://140.246.67.224:8089",
          href: "http://quality.liaowangyun.com:8082/#/",
          discrib: "",
        },
        aiBox: {
          tips: "",
          info: "",
          time: "",
          title: "AI演示平台",
          img: "/static/imgs/nav-aibox.png",
          // href: "http://140.246.67.224:8089",
          href: "http://114.115.143.236/environmentally/#/environmentally/aiBox",
          discrib: "",
        },
      },
      pcPlat: [
        "five",
        "one",
        "two",
        "three",
        "four",
        "ffkq",
        "qdys",
        "anshan",
        "guiyang",
        "noiselw",
        "newCloudPlatform",
        "aiBox",
      ],
      mobilePlat: ["one", "two", "four", "guiyang"],
    };
  },
  created() {
    for (let i = 0; i < this.menu.length; i++) {
      this.searchMenu = this.searchMenu.concat(this.menu[i].plat);
    }
  },
  computed: {
    lastLoginTime() {
      let obj = this.platObj;
      /*let obj = JSON.parse(localStorage.getItem('lastLoginTime'));
        if (obj == null) {
          obj = this.platObj;
        }*/
      let newObj = {};
      for (let k in obj) {
        newObj[k] = this.format(obj[k].time);
      }
      return newObj;
    },
  },
  methods: {
    onImageLoad() {
      this.isLoaded = true;
    },
    format(t) {
      let time;
      if (t == null || t == "") {
        time = new Date().getTime();
      } else {
        time = Number(t);
      }
      let date = new Date(time);
      let y = date.getFullYear();
      let mon = date.getMonth() + 1;
      mon = mon < 10 ? "0" + mon : mon;
      let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return y + "-" + mon + "-" + d + " " + h + ":" + m + ":" + s;
    },
    loginIn() {
      //环境网格化监管云平台
      $.ajax({
        url: "http://122.112.255.228:8089/login",
        type: "post",
        dataType: "json",
        data: {
          account: this.account,
          password: this.password,
          forceLogin: true,
        },
      })
        .done((res) => {
          if (res.info == "后台用户登录成功") {
            this.platObj.one.tips = "登录成功";
          } else {
            this.platObj.one.tips = res.info;
          }
          if (res.status) {
            this.platObj.one.time = new Date().getTime();
            localStorage.setItem("lastLoginTime", JSON.stringify(this.platObj));
          }
        })
        .fail((e) => {
          this.platObj.one.tips = "登录异常，请联系管理员";
        });
      //建筑工地扬尘监管平台
      $.ajax({
        url: "http://171.221.172.209:8082/wbacb/rfathc",
        type: "get",
        dataType: "json",
        data: null,
      })
        .done((res) => {
          if (res.status) {
            this.platObj.two.fillStr = res.data.authcode;
            this.platObj.two.prefix = res.data.secret_key;
            this.platObj.two.sessionID = res.data.sessionId;
            this.ycLogin();
          }
        })
        .fail((e) => {
          this.platObj.two.tips = "登录异常，请联系管理员";
        });

      // //环境大气污染监管平台
      $.ajax({
        url: "http://203.57.238.132:8081/sysl/login",
        type: "post",
        dataType: "json",
        data: {
          account: this.account,
          password: this.password,
          forceLogin: 1,
        },
      })
        .done((res) => {
          if (res.status) {
            if (res.message == "账号在别的地方被登录") {
              this.platObj.three.tips = "登录成功";
              this.platObj.three.time = new Date().getTime();
              localStorage.setItem("lastLoginTime", JSON.stringify(this.platObj));
            } else {
              this.platObj.three.time = new Date().getTime();
              localStorage.setItem("lastLoginTime", JSON.stringify(this.platObj));
              this.platObj.three.tips = res.message;
            }
          } else {
            this.platObj.three.tips = res.message;
          }
        })
        .fail((e) => {
          this.platObj.three.tips = "登录异常，请联系管理员";
        });
      //环境大气走航监管平台.
      $.ajax({
        // url: "http://140.246.67.224:8089/sysl/login",
        url: "http://203.25.219.120:8089/sysl/login",
        type: "post",
        dataType: "json",
        data: {
          account: this.account,
          password: this.password,
        },
      })
        .done((res) => {
          if (res.state == 1 && res.message == "重复登录") {
            this.platObj.four.tips = "登录成功";
            this.platObj.four.time = new Date().getTime();
            localStorage.setItem("lastLoginTime", JSON.stringify(this.platObj));
          } else if (res.message == "登录成功") {
            this.platObj.four.tips = "登录成功";
            this.platObj.four.time = new Date().getTime();
            localStorage.setItem("lastLoginTime", JSON.stringify(this.platObj));
          } else {
            this.platObj.four.tips = res.message;
          }
        })
        .fail((e) => {
          this.platObj.four.tips = "登录异常，请联系管理员";
        });
      //声环境监管平台
      $.ajax({
        url: "http://114.115.143.236:8093/authLogin/login",
        type: "post",
        dataType: "json",
        data: {
          account: this.account,
          password: this.password,
          type: "PC",
        },
      })
        .done((res) => {
          if (res.status) {
            if (res.msg == "登录成功") {
              this.platObj.noiselw.tips = "登录成功";
              this.platObj.noiselw.time = new Date().getTime();
              localStorage.setItem("lastLoginTime", JSON.stringify(this.platObj));
            } else {
              this.platObj.noiselw.time = new Date().getTime();
              localStorage.setItem("lastLoginTime", JSON.stringify(this.platObj));
              this.platObj.noiselw.tips = res.msg;
            }
          } else {
            this.platObj.noiselw.tips = res.msg;
          }
        })
        .fail((e) => {
          this.platObj.noiselw.tips = "登录异常，请联系管理员";
        });
      //智慧监管云平台
      $.ajax({
        url: "http://quality.liaowangyun.com:8070/auth/authLogin/login",
        type: "post",
        dataType: "json",
        data: {
          account: this.account,
          password: this.password,
          type: "PC",
        },
      })
        .done((res) => {
          console.log(res, 111);
          if (res.status) {
            if (res.msg == "登录成功") {
              this.platObj.newCloudPlatform.tips = "登录成功";
              this.platObj.newCloudPlatform.time = new Date().getTime();
              localStorage.setItem("lastLoginTime", JSON.stringify(this.platObj));
            } else {
              this.platObj.newCloudPlatform.time = new Date().getTime();
              localStorage.setItem("lastLoginTime", JSON.stringify(this.platObj));
              this.platObj.newCloudPlatform.tips = res.msg;
            }
          } else {
            this.platObj.newCloudPlatform.tips = res.msg;
          }
        })
        .fail((e) => {
          this.platObj.newCloudPlatform.tips = "登录异常，请联系管理员";
        });

      //四川瞭望数据质控平台
      $.ajax({
        url: "http://114.116.47.132:8089/login",
        type: "post",
        dataType: "json",
        data: {
          account: this.account,
          password: this.password,
          forceLogin: true,
        },
      })
        .done((res) => {
          if (res.status) {
            this.platObj.five.time = new Date().getTime();
            localStorage.setItem("lastLoginTime", JSON.stringify(this.platObj));
            this.platObj.five.tips = "登录成功";
          } else {
            if (res.info == "用户已经在线,如果需要请使用强制登陆!") {
              this.platObj.five.tips = "登录成功";
            } else {
              this.platObj.five.tips = res.info;
            }
          }
        })
        .fail((e) => {
          this.platObj.five.tips = "登录异常，请联系管理员";
        });

      //峰峰矿区
      $.ajax({
        url: "http://183.196.110.227:8089/login",
        type: "post",
        dataType: "json",
        data: {
          account: "FFKQ",
          password: "123456",
          forceLogin: true,
        },
      })
        .done((res) => {
          if (res.info == "登陆成功，跳转到主页") {
            this.platObj.ffkq.tips = "登录成功";
          } else {
            this.platObj.ffkq.tips = res.info;
          }
          if (res.status) {
            this.platObj.ffkq.time = new Date().getTime();
            localStorage.setItem("lastLoginTime", JSON.stringify(this.platObj));
          }
        })
        .fail((e) => {
          this.platObj.ffkq.tips = "登录异常，请联系管理员";
        });
      //青岛云顺
      $.ajax({
        url: "http://47.104.132.222:8089/login",
        type: "post",
        dataType: "json",
        data: {
          account: "test",
          password: "123456",
          forceLogin: true,
        },
      })
        .done((res) => {
          if (res.info == "登陆成功，跳转到主页") {
            this.platObj.qdys.tips = "登录成功";
          } else {
            this.platObj.qdys.tips = res.info;
          }
          if (res.status) {
            this.platObj.qdys.time = new Date().getTime();
            localStorage.setItem("lastLoginTime", JSON.stringify(this.platObj));
          }
        })
        .fail((e) => {
          this.platObj.qdys.tips = "登录异常，请联系管理员";
        });
      //吕梁
      // $.ajax({
      //   url: 'http://124.165.226.81:8082//validate',
      //   type: 'post',
      //   dataType: 'json',
      //   data: {
      //     user_name: 'test',
      //     password: '123456',
      //   }
      // }).done((res) => {
      //   if(res.info == '登陆成功，跳转到主页'){
      //     this.qdys.tips = '登录成功';
      //   } else {
      //     this.qdys.tips = res.info;
      //   }
      //   if(res.status){
      //     let time = new Date().getTime();
      //     localStorage.setItem('qdysLocal',time);
      //   }
      // }).fail((e) => {
      //   this.qdys.tips = '登录异常，请联系管理员'
      // })
      //鞍山市大气环境数据监管系统
      $.ajax({
        url: "http://203.86.74.218:8089/web-grid/login",
        type: "post",
        dataType: "json",
        data: {
          account: "test",
          password: "123456",
          forceLogin: true,
        },
      })
        .done((res) => {
          if (res.info == "登陆成功，跳转到主页") {
            this.platObj.anshan.tips = "登录成功";
          } else {
            this.platObj.anshan.tips = res.info;
          }
          if (res.status) {
            this.platObj.anshan.time = new Date().getTime();
            localStorage.setItem("lastLoginTime", JSON.stringify(this.platObj));
          }
        })
        .fail((e) => {
          this.platObj.anshan.tips = "登录异常，请联系管理员";
        });
      //贵阳市数字工地监测系统
      $.ajax({
        url: "http://114.115.222.141:8093/rfhack",
        // url: "http://222.85.139.153:8093/wlogin",
        type: "get",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        data: null,
      })
        .done((res) => {
          if (res.status) {
            this.platObj.guiyang.fillStr = res.data.authcode;
            this.platObj.guiyang.prefix = res.data.secret_key;
            this.platObj.guiyang.sessionID = res.data.sessionId;
            this.guiyangLogin();
          }
        })
        .fail((e) => {
          this.platObj.guiyang.tips = "登录异常，请联系管理员";
        });
    },
    ycLogin() {
      //建筑工地扬尘监管平台
      $.ajax({
        url: "http://122.112.255.228:8089/login",
        type: "post",
        dataType: "json",
        data: {
          account: this.account,
          // password: $.base64.encode(this.password),
          password: this.password,
          forceLogin: true,
          authcode: this.platObj.two.fillStr,
          sessionId: this.platObj.two.sessionID,
        },
      })
        .done((res) => {
          if (res.status) {
            this.platObj.two.time = new Date().getTime();
            localStorage.setItem("lastLoginTime", JSON.stringify(this.platObj));
            this.platObj.two.tips = "登录成功";
          } else {
            this.platObj.two.tips = res.info;
          }
        })
        .fail((e) => {
          this.platObj.two.tips = "登录异常，请联系管理员";
        });
    },
    guiyangLogin() {
      let password = Base64.encode(
        md5(this.platObj.guiyang.prefix + "ys123456").toUpperCase()
      );
      //建筑工地扬尘监管平台
      $.ajax({
        url: "http://114.115.222.141:8093/wlogin",
        type: "post",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        data: {
          account: "ys",
          password: password,
          forceLogin: true,
          authcode: this.platObj.guiyang.fillStr,
        },
      })
        .done((res) => {
          if (res.status) {
            this.platObj.guiyang.time = new Date().getTime();
            localStorage.setItem("lastLoginTime", JSON.stringify(this.platObj));
            this.platObj.guiyang.tips = "登录成功";
          } else {
            this.platObj.guiyang.tips = res.info;
          }
        })
        .fail((e) => {
          this.platObj.guiyang.tips = "登录异常，请联系管理员";
        });
    },
    toUrl(url, activeMenu) {
      this.flag.activeMenu = activeMenu;
      this.$router.push(url);
    },
    searchMune() {
      let name = this.dimKey;
      this.fuzzyMenu = this.searchMenu.filter((item) => {
        if (item.name.toUpperCase().indexOf(name.toUpperCase()) !== -1) {
          return item;
        }
      });
      $(".search-ul").show();
    },
    showSearchBox() {
      this.flag.showSearch = true;
    },
    focusInput() {
      this.dimKey = "";
      this.fuzzyMenu = [];
      $(".search-ul").hide();
    },
    qhdLogin() {
      // var formData = new FormData(document.getElementById("form"));
      // console.log(formData);
      var formData = new FormData();
      formData.append("account", "test");
      formData.append("password", "123456");
      formData.append("forceLogin", "true");

      $.ajax({
        type: "POST",
        dataType: "json",
        processData: false,
        contentType: false,
        url: "http://121.22.20.162:8082/validate",
        data: formData,
        success: function (result) {
          console.log(result);
        },
        error: function () {
          alert("异常！");
        },
      });
    },
    toassit() {
      window.open("http://114.115.143.236/assistant/#/", "_blank");
    },
    move(index) {
      this.fullpage.isScrolling = true; // 为了防止滚动多页，需要通过一个变量来控制是否滚动
      this.directToMove(index); //执行滚动
      setTimeout(() => {
        //这里的动画是1s执行完，使用setTimeout延迟1s后解锁
        this.fullpage.isScrolling = false;
      }, 1010);
    },
    // 执行滚动
    directToMove(index) {
      let height = this.$refs["fullPage"].clientHeight; //获取屏幕的宽度
      let scrollPage = this.$refs["fullPageContainer"]; // 获取执行tarnsform的元素
      let scrollHeight; // 计算滚动的告诉，是往上滚还往下滚
      scrollHeight = -(index - 1) * height + "px";
      scrollPage.style.transform = `translateY(${scrollHeight})`;
      this.fullpage.current = index;
    },
    // 往下切换
    next() {
      let len = 2; // 页面的个数
      if (this.fullpage.current + 1 <= len) {
        // 如果当前页面编号+1 小于总个数，则可以执行向下滑动
        this.fullpage.current += 1; // 页面+1
        this.move(this.fullpage.current); // 执行切换
      }
    },
    // 往上切换
    pre() {
      if (this.fullpage.current - 1 > 0) {
        // 如果当前页面编号-1 大于0，则可以执行向下滑动
        this.fullpage.current -= 1; // 页面+1
        this.move(this.fullpage.current); // 执行切换
      }
    },
    // 监听鼠标监听
    mouseWheelHandle(event) {
      // 添加冒泡阻止
      let evt = event || window.event;
      if (evt.stopPropagation) {
        evt.stopPropagation();
      } else {
        evt.returnValue = false;
      }
      if (this.fullpage.isScrolling) {
        // 判断是否可以滚动
        return false;
      }
      let e = event.originalEvent || event;
      this.fullpage.deltaY = e.deltaY || e.detail; // Firefox使用detail
      if (this.fullpage.deltaY > 0) {
        this.next();
      } else if (this.fullpage.deltaY < 0) {
        this.pre();
      }
    },
  },
  mounted() {
    console.log(this.$style);
    this.timer = setInterval(() => {
      this.loginIn();
      this.ycLogin();
      this.guiyangLogin();
    }, 60000);
    this.v_niceScroll = $(".niceScroll").niceScroll({
      cursoropacitymin: 0,
      cursoropacitymax: 0,
    });
    let that = this;
    this.$router.push("/all");
    $(".nav-box .nav-item").hover(
      function () {
        $(this).find(".plat").stop().slideDown(300);
        that.activeNav = $(this).attr("data-nav");
        that.$store.commit("changeActiveNav", $(this).attr("data-nav"));
      },
      function () {
        that.activeNav = "";
        $(this).find(".plat").stop().slideUp(300);
        that.$store.commit("changeActiveNav");
      }
    );
    this.loginIn();
    const image = document.getElementById("pageOne");
    // 添加事件监听器来处理拖拽事件
    // @ts-ignore
    image.addEventListener("dragstart", function (event) {
      // 阻止拖拽操作的默认行为
      event.preventDefault();
    });
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    $route(from, to) {
      this.flag.activeMenu = from.meta.index;
    },
    "flag.showSearch"(nval) {
      if (nval) {
        $(".search-box").css("display", "flex").siblings().css("display", "none");
      } else {
        $(".search-box").css("display", "none").siblings().css("display", "flex");
      }
    },
  },
};

function submitData() {
  $("form").ajaxSubmit(function (message) {
    console.log(message);
  });
  return false;
}
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: Tahoma;
}

.maintain {
  pointer-events: none;
  color: #808080 !important;
}
#home {
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
  overflow: auto;
}
.pageOneText {
  font-size: 28px;
  font-family: Source Han Sans SC VF, Source Han Sans SC VF;
  font-weight: 400;
  color: #b5c9d3;
}
.pageOne {
  margin: 0;
  font-size: 0;
  -webkit-user-select: none; /* Safari 3.1+ */
  -moz-user-select: none; /* Firefox 2+ */
  -ms-user-select: none; /* IE 10+ */
  user-select: none;
}
.pageOneBackground {
  width: 100%;
  height: 100vh;
  margin: 0;
  font-size: 0;
  overflow: hidden;
  position: relative;
  z-index: -1;
}
.pageTwo {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.topTitleAll {
  position: absolute;
  right: 0;
  text-align: right;
}

.top {
  height: 90px;
  display: flex;
  flex: 0 0 90px;
  background: rgba(55, 55, 55, 1);
}

.top-left {
  flex: 0 0 250px;
  padding: 20px 90px 20px 30px;
}

.top-left img {
  width: 100%;
  height: 100%;
}

.top-center {
  flex: 1 1 auto;
  width: 100%;
  /*overflow: hidden;*/
  position: relative;
}

.top-center .nav-box {
  display: flex;
  height: 100%;
}

.top-center .nav-box .nav-item {
  height: 100%;
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.nav-item p {
  color: #fff;
  cursor: default;
}

.nav-item p > span {
  margin-right: 10px;
}

.nav-item img {
  width: 14px;
  height: 14px;
  padding-top: 2px;
}

.nav-item.active img {
  transform: rotate(-180deg);
  transition: all 0.3s;
}

.nav-item p img {
  transform: rotate(0deg);
  transition: all 0.3s;
}

.nav-item .plat {
  width: 220px;
  position: absolute;
  left: 0px;
  top: 90px;
  background-color: rgba(55, 55, 55, 1);
  z-index: 10;
  display: none;
  box-shadow: inset 0px 1px 5px 1px rgba(255, 255, 255, 0.3);
  border-radius: 2px;
}

.nav-item .plat a {
  display: block;
  line-height: 30px;
  /*color: #B6B7B7;*/
  color: #e6e6e6;
  font-size: 12px;
  padding: 0 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
}

.nav-item .plat a:hover {
  /*color: #e5e5e5;*/
  color: #fff;
}

.search-box {
  background: rgba(55, 55, 55, 1);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 1px;
  left: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  display: none;
}

.search-box img {
  cursor: pointer;
}

.search-ul-box {
  height: 100%;
  width: 60%;
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}

.search-ul {
  width: 100%;
  padding: 0 10px;
  max-height: 200px;
  min-height: 100px;
  position: absolute;
  top: 90px;
  left: 0;
  box-sizing: border-box;
  border-radius: 3px;
  overflow: hidden;
  display: none;
}

.search-ul ul {
  list-style: none;
  width: 100%;
  background-color: #fff;
  box-shadow: 4px 1px 4px 6px rgba(0, 0, 0, 0.3);
  padding: 10px 0;
}

.search-ul li {
  background-color: #fff;
  color: #333;
  padding: 0 20px;
  line-height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-ul li:hover {
  background-color: #e5e5e5;
  color: #fff;
}

.search-ul li span {
  font-size: 14px;
  color: #333;
  text-decoration: none;
}

.search-ul li a {
  color: rgba(1, 125, 121, 1);
  font-size: 14px;
}

.search-box input {
  width: 100%;
  height: 50px;
  padding: 0 10px;
  background: transparent;
  border: 2px solid #333;
  outline: none;
  color: #b6b7b7;
  font-size: 15px;
  text-decoration: underline;
}

.search-box span {
  font-size: 18px;
  padding-bottom: 2px;
  text-decoration: underline;
  /*border-bottom: 1px solid rgba(85,85,85,1);*/
  color: #b6b7b7;
  cursor: default;
}

.search-box span:active {
  color: #e5e5e5;
}

.top-right {
  flex: 0 0 100px;
  margin-right: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.top-right.active {
  background-color: rgba(1, 125, 121, 1);
}

.top-right:hover {
  background-color: rgba(1, 125, 121, 1);
}

.center {
  flex: 1 1 auto;
  height: 100vh;
  overflow: auto;
  position: relative;
  background-color: #e5e5e5;
  display: flex;
  align-items: center;
  padding: 20px;
  flex-flow: column;
  background: url("/static/imgs/bg_home.png");
}

.center-p {
  color: white;
  font-size: 16px;
  font-weight: bold;
  z-index: 1;
  letter-spacing: 2px;
  margin-bottom: 20px;
}

.center > img {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.center > div {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  /*overflow: auto;*/
}

.center .item {
  width: calc((100% - 60px) / 4);
  height: 150px;
  margin-right: 20px;
  margin-bottom: 20px;
  overflow: auto;
  border: 1px solid #666;
  position: relative;
  z-index: 1;
  cursor: default;
}

.center .item:nth-child(4n) {
  margin-right: 0;
}

.center .item .item-title {
  display: flex;
  /*align-items: center;*/
  padding: 10px;
}

.center .item .item-title .img-icon {
  flex: 0 0 90px;
  height: 90px;
  margin-top: 10px;
}

.center .item .item-title .img-icon a,
.center .item .item-title .img-icon img {
  width: 100%;
  height: 100%;
}

.center .item .item-title .img-icon > a {
  display: flex;
  align-items: center;
  justify-content: center;
}

.center a {
  text-decoration: none;
}

.center .item .item-title .item-info {
  flex: 1 1 auto;
  width: 100%;
  overflow: hidden;
}

.center a {
  width: 100%;
}

.center .title {
  font-size: 20px;
  font-weight: 700;
  height: 30px;
  line-height: 40px;
  padding: 0 0 0 15px;
  color: #fff;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.center .status {
  line-height: 30px;
  padding: 15px 15px 0;
  font-size: 12px;
  color: #e5e5e5;
}

.center .status span {
  font-weight: bold;
}

.center .discrib {
  font-size: 12px;
  color: #e5e5e5;
  text-indent: 2em;
  padding: 20px 15px;
  line-height: 20px;
}

@media screen and (max-width: 1366px) {
  .center .item {
    width: calc((100% - 60px) / 4);
    height: auto;
  }

  .center .item .item-title .img-icon {
    flex: 0 0 70px;
    height: 70px;
    margin-top: 0;
  }
  .center .status {
    padding-left: 15px;
    padding-top: 10px;
    padding-right: 0;
    line-height: normal;
  }
  .center .title {
    font-size: 14px;
    line-height: normal;
    height: auto;
  }
}

.footer {
  height: 70px;
  width: 100%;
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.footer > div {
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer > div p {
  height: 100%;
  width: 120px;
  line-height: 35px;
  text-align: center;
  border-right: 1px solid rgba(85, 85, 85, 1);
  color: rgba(85, 85, 85, 1);
  cursor: pointer;
}

.footer > div p.active span {
  border-bottom: 1px solid rgba(85, 85, 85, 1);
}

.footer > div p:last-child {
  border-right: none;
}

.footer a {
  color: #ccc;
  text-decoration: none;
  letter-spacing: 2px;
  height: 30px;
  font-size: 12px;
}

.pageTwo {
  position: relative;
}
.endFooter {
  position: absolute;
  bottom: 0;
  height: 50px;
  width: 100%;
  z-index: 100;
}
.endFooter > a {
  text-align: center;
  line-height: 60px;
  color: white;
}
div::-webkit-scrollbar {
  width: 5px;
}

div::-webkit-scrollbar-track {
  background: #bfbfbf;
  border-radius: 2px;
}
div::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 2px;
}

div::-webkit-scrollbar-thumb:hover {
  background: #777;
}

div::-webkit-scrollbar-corner {
  background: #ddd;
}

div {
  /*三角箭头的颜色*/
  scrollbar-arrow-color: #ddd;
  /*滚动条滑块按钮的颜色*/
  scrollbar-face-color: #888;
  /*滚动条整体颜色*/
  scrollbar-highlight-color: #888;
  /*滚动条阴影*/
  scrollbar-shadow-color: #777;
  /*滚动条轨道颜色*/
  scrollbar-track-color: #bfbfbf;
  /*滚动条3d亮色阴影边框的外观颜色——左边和上边的阴影色*/
  scrollbar-3dlight-color: #bfbfbf;
  /*滚动条3d暗色阴影边框的外观颜色——右边和下边的阴影色*/
  scrollbar-darkshadow-color: #bfbfbf;
  /*滚动条基准颜色*/
  scrollbar-base-color: #bfbfbf;
}

/* 二维码 */
.codeScan {
  width: 11vw;
  height: 12.5vw;
  background: url("/static/imgs/codeBack.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  right: 0;
  top: 38vh;
}
.codeImg {
  width: 4.5vw;
  height: 4.5vw;
  margin-left: 45%;
  margin-top: 3.3vw;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue